var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"label-class",attrs:{"for":"uploadImage"},on:{"click":_vm.clickFile}},[_c('a-icon',{style:({fontSize: '20px', color: 'rgba(0, 0, 0, 0.65)', marginLeft: '8px'}),attrs:{"type":"picture"}}),_c('input',{ref:"imgDom",staticClass:"hide",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.pictureChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }